import {
  APP_LP_URL,
  ARTICLES,
  CHIRA_CEO_URL,
  COMPANY,
  EVENTS_URL,
  HIRING_URL,
  NOTE_URL,
  STORIES,
  STORIES_FEATURE,
  STORIES_NEW,
  STORIES_POPULAR,
} from 'src/utils/routes'
import { DropDownMenuProps } from './types'

export const INTREVIEW: DropDownMenuProps = {
  title: '決裁者インタビュー',
  items: [
    {
      href: STORIES,
      label: 'インタビューを検索',
    },
    {
      href: STORIES_NEW,
      label: '新着記事',
    },
    {
      href: STORIES_POPULAR,
      label: '人気記事',
    },
    {
      href: STORIES_FEATURE,
      label: '特集記事',
    },
  ],
}

export const SERVICE: DropDownMenuProps = {
  title: 'サービス概要',
  items: [
    {
      href: APP_LP_URL,
      label: '決裁者のための経営相談・発注先探しサービス「ONLYSTORY」',
    },
    {
      href: CHIRA_CEO_URL,
      label: '決裁者限定マッチングプラットフォーム「チラCEO」',
    },
    {
      href: EVENTS_URL,
      label: '会員様限定イベント',
    },
  ],
}

export const ABOUT: DropDownMenuProps = {
  title: '運営会社',
  items: [
    {
      href: COMPANY,
      label: '会社概要',
    },
    {
      href: HIRING_URL,
      label: '採用情報',
    },
    {
      href: NOTE_URL,
      label: '代表平野のnote一覧',
    },
    {
      href: ARTICLES,
      label: 'お知らせ',
    },
  ],
}
